<template>
  <div class="overflow-hidden max-h-full">
    <Alert :type="'info'" :icon="'far fa-circle-info'">
      Please Note: All topics deliver at least one lesson per year, unless a single lesson topic has greater than 1-year periodicity.
    </Alert>
    <Alert :type="'info'" :icon="'far fa-circle-info'">
      Except for topics based on calendar date expiry [
      <el-tooltip content="Expiration: Calendar day expiration" placement="top">
        <i class="far fa-calendar-alt text-warning" />
      </el-tooltip>
      ], topic expiry is based on the first date of topic completion if all
      subsequent completions are accomplished within 60 days of the first
      expiry. Thus, it is possible to have expiry dates which appear to slightly
      exceed periodicity.
    </Alert>
  </div>
</template>

<script>
import Alert from "../../../../../UIComponents/Alert.vue";
export default {
  components: {
    Alert,
  },
};
</script>

<style lang="scss" scoped></style>
